@if (content.layout !== 'simple') {
    <sirius-utility-bar
        [culture]="culture"
        [activeTab]="'main'"
        [languages]="content.languages"
        [globalLinks]="content.menu.utilityLinks">
    </sirius-utility-bar>
}
